import $ from 'jquery'
window.jQuery = $;
window.$ = $;
import Swiper from 'swiper';
import ymaps from 'ymaps';
import Inputmask from "inputmask";
import VALIDATION from './components/validation';
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueAgile from 'vue-agile'

import { store } from './store/store';
// import './derectives/ClickOutsideOfElement'

window.Vue = require('vue');
locale.use(lang)
Vue.use(ElementUI);
Vue.use(VueAgile)
const files = require.context('./components', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('Treeselect', Treeselect)

store.subscribe(() => {
    localStorage.setItem('state', JSON.stringify(store.state));
});

const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)



let handleOutsideClick
Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        handleOutsideClick = (e) => {
            e.stopPropagation()
            const { handler, exclude } = binding.value
            let clickedOnExcludedEl = false
            exclude.forEach(refName => {
                if (!clickedOnExcludedEl) {
                    const excludedEl = vnode.context.$refs[refName]
                    clickedOnExcludedEl = excludedEl.contains(e.target)
                }
            })
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler]()
            }
        }
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },

    unbind() {
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
})

new Vue({
    store,
    beforeCreate() {
        this.$store.commit('initializeState');
        this.$store.dispatch('setXlsxWorksList');

    },
}).$mount("#formApp");
new Vue({
    store,
    beforeCreate() {
        this.$store.commit('initializeState');
    },
}).$mount("#searchApp");
new Vue({
    store,
    beforeCreate() {
        this.$store.commit('initializeState');
    },
}).$mount("#mapVue");


let tel_inp = document.querySelectorAll('input[type="tel"]');
if (tel_inp.length) {
    tel_inp.forEach((item) => {
        Inputmask({ mask: '+375(99)999-99-99', greedy: true }).mask(item);
    })
}


window.addEventListener('submit', (e) => {
    e.preventDefault();

    if (e.target.classList.contains('vue-form')) {
        return;
    }

    if (VALIDATION(e.target)) {


        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'post',
            data: $(e.target).serialize(),
            success: function (result) {
                e.target.reset();
            },
            error: function (error) {
                console.log(error.responseJson)
            },
            complete: function(){
                window.location = '/thanks'
            }
        })
    }

})

// ---------------------- SLider ----------------------------------

new Swiper('.slider__container', {
    loop: true,
    loopedSlides: 5,
    slidesPerView: 3,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        480: {
            slidesPerView: 2,
        },
        900: {
            slidesPerView: 3,
            centeredSlides: true,
        }
    }

})

// ---------------------- End SLider ------------------------------

$(document).ready(function () {
    let tel_inp = document.querySelector('input[type="tel"]');
    if (tel_inp) {
        let im = new Inputmask("+375 (99) 999-99-99");
        im.mask(tel_inp);
    }
    $(window).on('scroll', function () {
        let arr = [...$(".services__icn div span")];
        if (arr) {
            arr.forEach((item, index) => {
                if (index > 1) {
                    scrolling(item, index, $('.services'))
                }
            })
        }
        let arr2 = [...$(".about-company__icn div span")];
        if (arr2) {
            arr2.forEach((item, index) => {
                scrolling(item, index, $('.about-company'))
            })
        }
        let arr3 = [...$(".video-block__icn div span")];
        if (arr3) {
            arr3.forEach((item, index) => {
                if (index > 0) {
                    scrolling(item, index, $('.video-block'))
                }
            })
        }
        let arr4 = [...$(".calculator__icn div span")];
        if (arr4) {
            arr4.forEach((item, index) => {
                if (index > 0) {
                    scrolling(item, index, $('.calculator'))
                }
            })
        }
        let arr5 = [...$(".mapVue__icn div span")];
        if (arr5) {
            arr5.forEach((item, index) => {
                scrolling(item, index, $('.mapVue'))
            })
        }
    })
    $('body').on('click', function () {
        if ($('.thanks-popup').hasClass('open')) {
            $('.thanks-popup').removeClass('open')
        }
    })
    $('.popup-cart').on('click', function (e) {
        if ($(e.target).hasClass('overlay') || $(e.target).is('button.close')) {
            $('.popup-cart').removeClass('open')
            $('body').css('overflow', '')

        }
    })
    $('.js-send-request').on('click', function () {
        $('.thanks-popup').addClass('open')
        if ($('.thanks-popup').hasClass('open')) {
            setTimeout(() => {
                $('.popup-cart').removeClass('open')
                $('.thanks-popup').removeClass('open')
                $('body').css('overflow', '')
            }, 2000)
        }
    })
    $('.js-request-popup').on('click', function (e) {
        console.log(e.target);
        $('.request_popup').addClass('open')
        $('body').css('overflow', 'hidden')
    })
    // $('.js-btn-privacy').on('click', function () {
    //     $('.privacy_popup').addClass('open')
    //     $('body').css('overflow', 'hidden')
    // })
    $('.request_popup').on('click', function (e) {
        if ($(e.target).hasClass('overlay') || $(e.target).is('button.close')) {
            $('.request_popup').removeClass('open')
            $('body').css('overflow', '')
        }
    })
    // $('.privacy_popup').on('click', function (e) {
    //     if ($(e.target).hasClass('overlay') || $(e.target).is('button.close')) {
    //         $('.privacy_popup').removeClass('open')
    //         $('body').css('overflow', '')
    //     }
    // })
    $('.to-app').on('click', function () {
        $('.request_popup').removeClass('open')
        $('body').css('overflow', '')
        setTimeout(() => {
            $(".app")[0].scrollIntoView({ block: "start" });
        }, 100)
    })

})
function scrolling(item, index, wrapper) {
    let top;
    if ($(item).width() < 50) {
        top = ($(window).scrollTop() - (wrapper.offset().top - 165)) / 5;
    } else if ($(item).width() >= 100) {
        top = ($(window).scrollTop() - (wrapper.offset().top - 165)) / -25;
    } else {
        top = ($(window).scrollTop() - (wrapper.offset().top - 165)) / 7.5;
    }
    $(item).css('transform', `translateY(${top}px)`)
}
document.addEventListener('DOMContentLoaded', function () {
    let pagination = document.querySelector('.nav-pagination');
    let sections = document.querySelectorAll('main > section');
    sections.forEach((item, index) => {
        if(!item.classList.contains('thanks')){
            pagination.innerHTML += `<a href="#${item.getAttribute('id')}" style="animation-delay: ${index * 0.1}s"><span></span></a>`
        let span = document.querySelectorAll('.nav-pagination a')
        span[0].classList.add('active')
        window.addEventListener('scroll', function () {
            let span = document.querySelectorAll('.nav-pagination a')
            if (item.getBoundingClientRect().top > -100 && item.getBoundingClientRect().top < 100) {
                span.forEach(el => {
                    el.classList.remove('active')
                })
                span[index].classList.add('active');
            }
        })
        }
    })
    if (window.IntersectionObserver) {

        const observer = new IntersectionObserver((entries, observer) => {
            // для каждой записи-целевого элемента
            entries.forEach(entry => {
                // если элемент является наблюдаемым
                if (entry.isIntersecting) {
                    const lazyImg = entry.target
                    lazyImg.src = lazyImg.dataset.src;
                    observer.unobserve(lazyImg)
                }
            })
        })

        // с помощью цикла следим за всеми img на странице
        const arr = document.querySelectorAll('.lazy')
        arr.forEach(i => {
            observer.observe(i)
        })

        $('.burger').on('click', function () {
            $(this).addClass('active');
            $('html').css('overflow', 'hidden')
            $(this).siblings('.menu-mob').addClass('active');
        })
        $('.menu-mob').on('click', function (e) {
            if ($(e.target).hasClass('overlay') || $(e.target).is('.close-burger')) {
                $('html').css('overflow', '')
                $(this).removeClass('active');
            }
        })
        $('.menu-mob > div > ul a').on('click', function(){
            $('html').css('overflow', '')
            $('.menu-mob').removeClass('active');
        })
    }


})
